import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaSave, FaTrash, FaPlus, FaLink, FaImage, FaChartBar, FaMagic } from 'react-icons/fa';
import { RiMailSendLine } from 'react-icons/ri';
import api from '../../services/api';
import { useHistory, Link } from 'react-router-dom';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import { pontoVirgula } from '../../util/util';
import { FinField, FinInput, FinCheck, FinChecks } from '../../components/FinField';
import '../../css/financeiro-parcela-pagar.css';


const URL_PESQUISA_CLIENTE = process.env.REACT_APP_CLIENTE_URL || 'https://cliente.infoaccess-mkt.com.br';

// Modelo do texto das perguntas geradas por opção. O operador reescreve como
// quiser — {item} é onde o nome da opção entra.
const MODELO_PADRAO = 'Qual sua nota de 0 a 10 sobre {item}?';
const TEM_PLACEHOLDER = /\{\s*(item|opcao|opção)\s*\}/i;
const aplicarModelo = (modelo, opcao) => TEM_PLACEHOLDER.test(modelo)
    ? modelo.replace(/\{\s*(item|opcao|opção)\s*\}/gi, opcao)
    : modelo + ' — ' + opcao;
const itensDe = (p) => ((p && p.opcoesTexto) || '').split('\n').map(x => x.trim()).filter(Boolean);

export default function CadastroEventoSatisfacaoPergunta({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(!!id);
    const [perguntasSatisfacao, setPerguntasSatisfacao] = useState([]);
    const [enviandoEmail, setEnviandoEmail] = useState(false);
    // Imagem de fundo da pesquisa (aparece na tela pública do participante).
    // { id, link } — null = sem imagem, a pesquisa usa o visual padrão.
    const [imagemFundo, setImagemFundo] = useState(null);
    const [enviandoImagem, setEnviandoImagem] = useState(false);
    // Multi-idioma: catálogo + idiomas que ESTE evento oferece + traduções por
    // pergunta. abaIdioma controla o modo da lista: português edita a estrutura,
    // outro idioma edita só os textos traduzidos.
    const [idiomasInfo, setIdiomasInfo] = useState({ catalogo: [], oferecidos: [] });
    const [abaIdioma, setAbaIdioma] = useState('portugues');
    const [traducoes, setTraducoes] = useState({});   // `${idioma}:${perguntaId}` -> {pergunta_texto, instrucao, opcoesTexto}
    const [salvandoIdiomas, setSalvandoIdiomas] = useState(false);
    const [salvandoTraducoes, setSalvandoTraducoes] = useState(false);
    const [traduzindo, setTraduzindo] = useState(false);
    const history = useHistory();

    const enviarEmailParaTodos = () => {
        Alert({
            title: 'Enviar e-mail da pesquisa para todos os participantes?',
            html: 'Será enviado um e-mail cordial para cada participante do evento com o link personalizado da pesquisa (sem necessidade de login por e-mail).',
            confirmButton: 'Enviar',
            denyButton: 'Cancelar',
            callBack: (result) => {
                if (!result.isConfirmed) return;
                setEnviandoEmail(true);
                api({
                    method: 'post',
                    action: `/eventoSatisfacaoPergunta/enviarEmailPesquisa/${id}`,
                    token: token,
                })
                    .then((response) => {
                        const data = response.data?.data ?? response.data;
                        if (data.quantidadeSucesso > 0) {
                            toast.success(data.quantidadeSucesso + ' e-mail(s) enviado(s) com sucesso.');
                        }
                        (data.erros || []).forEach((erro) => {
                            toast.error(erro.mensagem);
                        });
                    })
                    .catch((error) => {
                        toast.error('Erro: ' + (error.response?.data?.error ?? 'ao enviar e-mails'));
                    })
                    .finally(() => setEnviandoEmail(false));
            }
        });
    };

    // Upload/exclusão da imagem agem NA HORA (endpoint próprio), sem depender do
    // Salvar da tela: o Salvar manda JSON puro e o api.js trata PUT+FormData de forma
    // diferente — misturar arquivo ali seria pedir bug silencioso.
    const enviarImagemFundo = (arquivo) => {
        if (!arquivo) return;
        if (!/\.(jpe?g|png|webp)$/i.test(arquivo.name || '')) {
            toast.error('Envie uma imagem JPG, PNG ou WEBP.');
            return;
        }
        setEnviandoImagem(true);
        const formData = new FormData();
        formData.append('file', arquivo);
        fetch(process.env.REACT_APP_API_URL + '/eventoSatisfacaoPergunta/' + id + '/imagemFundo', {
            method: 'POST',
            headers: { Authorization: 'Bearer ' + token },
            body: formData,
        })
            .then(r => r.json())
            .then(j => {
                if (j && j.data && j.data.imagemfundosatisfacao) {
                    setImagemFundo({ id: String(j.data.imagemfundosatisfacao), link: j.data.link || null });
                    toast.success('Imagem de fundo atualizada!');
                } else {
                    toast.error((j && (j.error || j.msg)) || 'Erro ao enviar a imagem.');
                }
            })
            .catch(() => toast.error('Erro ao enviar a imagem.'))
            .finally(() => setEnviandoImagem(false));
    };

    const excluirImagemFundo = () => {
        if (!window.confirm('Remover a imagem de fundo? A pesquisa volta ao visual padrão.')) return;
        setEnviandoImagem(true);
        api({ method: 'delete', action: '/eventoSatisfacaoPergunta/' + id + '/imagemFundo', token: token })
            .then(() => { setImagemFundo(null); toast.success('Imagem removida.'); })
            .catch(err => toast.error(err?.response?.data?.error || 'Erro ao remover a imagem.'))
            .finally(() => setEnviandoImagem(false));
    };

    const carregarIdiomas = () => {
        if (!id) return;
        api({ method: 'get', action: '/eventoSatisfacaoPergunta/' + id + '/idiomas', token })
            .then(response => {
                const d = response.data?.data || {};
                setIdiomasInfo({ catalogo: d.catalogo || [], oferecidos: d.oferecidos || [] });
                const mapa = {};
                (d.traducoes || []).forEach(t => {
                    mapa[t.idioma + ':' + t.pergunta_id] = {
                        pergunta_texto: t.pergunta_texto || '',
                        instrucao: t.instrucao || '',
                        opcoesTexto: (t.opcoes && Array.isArray(t.opcoes.itens)) ? t.opcoes.itens.join('\n') : '',
                    };
                });
                setTraducoes(mapa);
            })
            .catch(() => { /* API antiga: a tela segue só em português */ });
    };

    // Marca/desmarca um idioma oferecido. Adicionar dispara a tradução
    // automática no servidor (Cloud Translation) — o resultado volta no toast.
    const alternarIdioma = (codigo) => {
        if (salvandoIdiomas) return;
        const atual = idiomasInfo.oferecidos || [];
        const novos = atual.includes(codigo) ? atual.filter(c => c !== codigo) : [...atual, codigo];
        setSalvandoIdiomas(true);
        api({ method: 'put', action: '/eventoSatisfacaoPergunta/' + id + '/idiomas', token, data: { idiomas: novos } })
            .then(response => {
                const d = response.data?.data || {};
                const resultado = d.traducao && d.traducao[codigo];
                if (resultado && resultado.traduzidas > 0) {
                    toast.success(resultado.traduzidas + ' pergunta(s) traduzidas automaticamente — revise na aba do idioma.');
                } else if (!atual.includes(codigo)) {
                    toast.success('Idioma atualizado.');
                } else {
                    toast.success('Idioma removido da pesquisa.');
                }
                (d.avisos || []).forEach(a => toast.warning(a));
                carregarIdiomas();
            })
            .catch(err => toast.error(err.response?.data?.error ?? 'Erro ao salvar idiomas.'))
            .finally(() => setSalvandoIdiomas(false));
    };

    // Re-traduz o que ainda não tem tradução (ex.: perguntas criadas depois).
    const traduzirFaltantes = () => {
        if (traduzindo || abaIdioma === 'portugues') return;
        setTraduzindo(true);
        api({ method: 'post', action: '/eventoSatisfacaoPergunta/' + id + '/traduzir', token, data: { idioma: abaIdioma } })
            .then(response => {
                const d = response.data?.data || {};
                toast.success((d.traduzidas || 0) + ' traduzida(s), ' + (d.mantidas || 0) + ' já revisadas mantidas.');
                carregarIdiomas();
            })
            .catch(err => toast.error(err.response?.data?.error ?? 'Erro ao traduzir.'))
            .finally(() => setTraduzindo(false));
    };

    const mutTraducao = (perguntaId, campo, valor) => {
        const chave = abaIdioma + ':' + perguntaId;
        setTraducoes(prev => ({ ...prev, [chave]: { ...(prev[chave] || { pergunta_texto: '', instrucao: '', opcoesTexto: '' }), [campo]: valor } }));
    };

    const salvarTraducoes = () => {
        if (salvandoTraducoes || abaIdioma === 'portugues') return;
        const pendentes = perguntasSatisfacao
            .filter(pergunta => pergunta.id)
            .map(pergunta => {
                const t = traducoes[abaIdioma + ':' + pergunta.id];
                if (!t) return null;
                return api({
                    method: 'put', action: '/eventoSatisfacaoPergunta/traducao/' + pergunta.id, token,
                    data: {
                        idioma: abaIdioma,
                        pergunta_texto: t.pergunta_texto || null,
                        instrucao: t.instrucao || null,
                        opcoes: (t.opcoesTexto || '').trim() !== ''
                            ? { itens: t.opcoesTexto.split('\n').map(x => x.trim()).filter(Boolean) }
                            : null,
                    },
                });
            })
            .filter(Boolean);
        if (pendentes.length === 0) { toast.info('Nada para salvar neste idioma.'); return; }
        setSalvandoTraducoes(true);
        Promise.all(pendentes)
            .then(() => toast.success('Traduções salvas!'))
            .catch(() => toast.error('Erro ao salvar uma das traduções — confira e tente de novo.'))
            .finally(() => setSalvandoTraducoes(false));
    };

    const buscar = () => {
        setIsLoading(true);
        if (id) {
            api({
                method: "get",
                action: '/eventoSatisfacaoPergunta/' + id,
                token: token,
            }).then(response => {
                setDados({
                    nome: response.data.data.dadosEvento.nome ?? null,
                    quantidadeConvidados: response.data.data.dadosEvento.quantidadeConvidados ?? null,
                    quantidadeConvidadosNaoCompareceram: response.data.data.dadosEvento.quantidadeConvidadosNaoCompareceram ?? null,
                    duracaoEvento: response.data.data.dadosEvento.duracaoEvento ?? null,
                    mediaPermanenciaConvidados: response.data.data.dadosEvento.mediaPermanenciaConvidados ?? null,
                    ocultarmarcasatisfacao: !!response.data.data.dadosEvento.ocultarmarcasatisfacao,
                    loginsatisfacao: response.data.data.dadosEvento.loginsatisfacao || 'email'
                });
                const ev = response.data.data.dadosEvento || {};
                // A relação vem em camelCase ou snake_case dependendo do serializer —
                // aceita os dois para não quebrar silenciosamente (imagem sumiria da tela).
                const arq = ev.imagemfundo_satisfacao || ev.ImagemfundoSatisfacao || ev.imagemfundosatisfacao_arquivo || null;
                setImagemFundo(ev.imagemfundosatisfacao
                    ? { id: String(ev.imagemfundosatisfacao), link: (arq && arq.link) || null }
                    : null);
                const ps = (response.data.data.perguntasSatisfacao || []).map(p => ({
                    ...p,
                    notaMin: p.notaMin != null ? p.notaMin : 0,
                    notaMax: p.notaMax != null ? p.notaMax : 10,
                    tipoResposta: p.tipoResposta || 'nota',
                    secao: p.secao || '',
                    instrucao: p.instrucao || '',
                    permiteNaoParticipei: !!p.permiteNaoParticipei,
                    nps: !!p.nps,
                    // opcoes vem como {itens:[], permite_outro} — para editar, vira
                    // texto com uma opção por linha (formato natural de digitar)
                    opcoesTexto: (p.opcoes && Array.isArray(p.opcoes.itens)) ? p.opcoes.itens.join('\n') : '',
                    permiteOutro: !!(p.opcoes && p.opcoes.permite_outro),
                    encerraSecao: (p.opcoes && p.opcoes.encerra_secao) || '',
                    condicaoIndex: p.condicaoIndex != null ? p.condicaoIndex : '',
                    condicaoOpcao: p.condicaoOpcao || ''
                }));
                setPerguntasSatisfacao(ps);
            }).catch(err => {
                toast.error('Erro ao carregar dados: ' + (err.response?.data?.error ?? err.message));
            }).finally(() => { setIsLoading(false); });
        } else {
            setIsLoading(false);
        }
    };

    // A condição aponta para a pergunta-fonte pelo ÍNDICE no array. Toda vez que
    // uma pergunta entra ou sai do MEIO da lista, os índices depois do ponto se
    // deslocam — sem remapear, a condição passaria a apontar para a pergunta
    // errada em silêncio (o participante veria a pergunta na hora errada).
    const deslocarCondicoes = (lista, posicao, delta) => lista.map(p => (
        (p.condicaoIndex !== '' && p.condicaoIndex != null && p.condicaoIndex >= posicao)
            ? { ...p, condicaoIndex: p.condicaoIndex + delta }
            : p
    ));

    // Perguntas presas a uma opção que não existe mais na fonte: não aparecem
    // para ninguém. Nunca apagamos sozinhos — só avisamos (decisão do Rafael).
    const perguntasOrfas = (lista) => lista.filter(p => {
        if (p.condicaoIndex === '' || p.condicaoIndex == null) return false;
        const fonte = lista[p.condicaoIndex];
        if (!fonte) return true;
        return !!p.condicaoOpcao && !itensDe(fonte).includes(p.condicaoOpcao);
    });

    const removerPergunta = (index) => {
        const dependentes = perguntasSatisfacao.filter(p => p.condicaoIndex === index).length;
        if (dependentes > 0 && !window.confirm(
            'Esta pergunta é a condição de ' + dependentes + ' pergunta(s). Removendo, essas perguntas passam a aparecer para todo mundo. Remover mesmo assim?')) {
            return;
        }
        let novas = perguntasSatisfacao.map(p => (
            p.condicaoIndex === index ? { ...p, condicaoIndex: '', condicaoOpcao: '' } : p
        ));
        novas = deslocarCondicoes(novas, index + 1, -1);
        novas.splice(index, 1);
        setPerguntasSatisfacao(novas);
    };

    // Cria uma pergunta por opção da escolha, já amarrada àquela opção. O motor
    // de condição é o mesmo de sempre — isto só evita montar e amarrar na mão.
    const gerarPerguntasPorOpcao = (index) => {
        const fonte = perguntasSatisfacao[index];
        const itens = itensDe(fonte);
        if (itens.length === 0) {
            toast.warning('Digite as opções (uma por linha) antes de gerar as perguntas.');
            return;
        }
        const modelo = (fonte.modeloItem != null ? fonte.modeloItem : MODELO_PADRAO).trim();
        if (!modelo) {
            toast.warning('Escreva o texto que vai virar a pergunta de cada opção.');
            return;
        }
        const jaAmarradas = perguntasSatisfacao
            .filter(p => p.condicaoIndex === index && p.condicaoOpcao)
            .map(p => p.condicaoOpcao);
        const faltando = itens.filter(op => !jaAmarradas.includes(op));
        if (faltando.length === 0) {
            toast.info('Todas as opções desta pergunta já têm a sua pergunta.');
            return;
        }
        if (!TEM_PLACEHOLDER.test(modelo) && !window.confirm(
            'O modelo não tem {item}, então o nome da opção vai entrar no fim do texto. Gerar assim mesmo?')) {
            return;
        }
        // Entram logo depois da última pergunta que já pertence a esta fonte,
        // para o bloco ficar junto e na ordem das opções.
        let posicao = index + 1;
        perguntasSatisfacao.forEach((p, i) => {
            if (p.condicaoIndex === index && i >= posicao) posicao = i + 1;
        });
        const geradas = faltando.map(op => ({
            pergunta: aplicarModelo(modelo, op),
            notaMin: 0,
            notaMax: 10,
            tipoResposta: fonte.tipoItem || 'nota',
            secao: fonte.secao || '',
            instrucao: '',
            permiteNaoParticipei: false,
            nps: false,
            opcoesTexto: '',
            permiteOutro: false,
            encerraSecao: '',
            condicaoIndex: index,
            condicaoOpcao: op
        }));
        const novas = deslocarCondicoes(perguntasSatisfacao, posicao, geradas.length);
        novas.splice(posicao, 0, ...geradas);
        setPerguntasSatisfacao(novas);
        toast.success(geradas.length === 1
            ? '1 pergunta gerada — aparece só para quem marcar aquela opção.'
            : geradas.length + ' perguntas geradas — cada uma aparece só para quem marcar a sua opção.');
    };

    const salvar = () => {

        if (isSubmitting) {
            return;
        }

        const orfas = perguntasOrfas(perguntasSatisfacao);
        if (orfas.length > 0 && !window.confirm(
            orfas.length + ' pergunta(s) estão presas a uma opção que não existe mais e não vão aparecer para ninguém. Salvar assim mesmo?')) {
            return;
        }

        setIsSubmitting(true);
        delete dados.nome; //não precisa enviar

        api({
            method: 'put',
            action: '/eventoSatisfacaoPergunta/' + id,
            token: token,
            data: {
                dados: dados,
                perguntasSatisfacao: perguntasSatisfacao.map(p => {
                    // modeloItem/tipoItem só servem ao gerador aqui na tela
                    const { modeloItem, tipoItem, ...resto } = p;
                    return {
                        ...resto,
                        condicaoIndex: p.condicaoIndex === '' ? null : p.condicaoIndex,
                        opcoes: {
                            itens: itensDe(p),
                            permite_outro: !!p.permiteOutro,
                            encerra_secao: p.encerraSecao || null,
                        },
                    };
                }),
                perguntasConversao: []
            }
        })
            .then(function (response) {
                toast.success('Perguntas salvas com sucesso!');
                history.push("/evento");
            })
            .catch(function (error) {
                toast.error('Erro ao salvar perguntas: ' + (error.response?.data?.error ?? error.message));
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    useEffect(() => {
        buscar();
        carregarIdiomas();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Perguntas de Satisfação do Evento</h1></div>
                    <div className="fin-pp__actions">
                        {id && (
                            <Link to={'/eventoSatisfacaoResultado/' + id} className="fin-pp__btn fin-pp__btn--sm" style={{ textDecoration: 'none' }}>
                                <FaChartBar size={14} /> Resultados
                            </Link>
                        )}
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--sm"
                            onClick={() => {
                                const link = `${URL_PESQUISA_CLIENTE}/perguntassatisfacao/${id}`;
                                navigator.clipboard.writeText(link).then(() => {
                                    toast.success('Link copiado! Envie este link aos participantes para responderem à pesquisa.');
                                }).catch(() => toast.error('Não foi possível copiar o link.'));
                            }}
                        >
                            <FaLink size={14} /> Copiar link da pesquisa
                        </button>
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--sm"
                            disabled={enviandoEmail}
                            onClick={enviarEmailParaTodos}
                        >
                            <RiMailSendLine size={14} /> {enviandoEmail ? 'Enviando...' : 'Enviar e-mail para todos'}
                        </button>
                        <button type="button" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting} onClick={salvar}>
                            {isSubmitting ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</> : <><FaSave size={16} /> Salvar</>}
                        </button>
                    </div>
                </div>

                <form onSubmit={e => { e.preventDefault(); salvar(); }}>
                    <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                        <div className="fin-pp__cphead" style={{ marginBottom: 12 }}>
                            <h2 className="fin-pp__cphead-title">Quantidade de Convidados</h2>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Quantidade de Convidados">
                                <FinInput
                                    type="text"
                                    value={dados.quantidadeConvidados || ''}
                                    onChange={e => setDados({ ...dados, ...{ "quantidadeConvidados": e.target.value } })}
                                />
                            </FinField>
                            <FinField label="Quant. Conv. Não Compareceram">
                                <FinInput
                                    type="text"
                                    value={dados.quantidadeConvidadosNaoCompareceram || ''}
                                    onChange={e => setDados({ ...dados, ...{ "quantidadeConvidadosNaoCompareceram": e.target.value } })}
                                />
                            </FinField>
                        </div>

                        <div className="fin-pp__cphead" style={{ marginBottom: 12, marginTop: 16 }}>
                            <h2 className="fin-pp__cphead-title">Watching Time</h2>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Duração Evento (min)">
                                <FinInput
                                    type="text"
                                    value={dados.duracaoEvento || ''}
                                    onChange={e => setDados({ ...dados, ...{ "duracaoEvento": e.target.value } })}
                                />
                            </FinField>
                            <FinField label="Média Permanência Convidados (min)">
                                <FinInput
                                    type="text"
                                    value={pontoVirgula(dados.mediaPermanenciaConvidados)}
                                    onChange={e => setDados({ ...dados, ...{ "mediaPermanenciaConvidados": e.target.value } })}
                                />
                            </FinField>
                        </div>
                    </div>

                    {/* Dado que o participante informa no login da pesquisa. Grava junto com o Salvar da tela. */}
                    <div className="fin-pp__card" style={{ padding: '14px 16px', marginBottom: 16 }}>
                        <div className="fin-pp__cphead" style={{ marginBottom: 10 }}>
                            <div>
                                <h2 className="fin-pp__cphead-title" style={{ fontSize: 15 }}>Acesso do Participante</h2>
                                <p className="fin-pp__cphead-sub">O participante entra na pesquisa com este dado, que precisa estar no cadastro dele.</p>
                            </div>
                        </div>
                        <FinField label="Entrar com">
                            <FinChecks inline>
                                {[['email', 'E-mail'], ['celular', 'Celular'], ['cpf', 'CPF']].map(([valor, rotulo]) => (
                                    <FinCheck key={valor} id={'login-satisfacao-' + valor} type="radio" name="loginsatisfacao" label={rotulo}
                                        checked={dados.loginsatisfacao === valor}
                                        onChange={() => setDados({ ...dados, loginsatisfacao: valor })} />
                                ))}
                            </FinChecks>
                        </FinField>
                    </div>

                    {/* ── Imagem de fundo da pesquisa ─────────────────────────
                        Aparece na tela pública onde o participante responde. Sem imagem,
                        a pesquisa mantém o visual padrão. Sobe para o mesmo storage
                        (GCS) de todos os arquivos do sistema. */}
                    <div className="fin-pp__card" style={{ padding: '14px 16px', marginBottom: 16 }}>
                        <div className="fin-pp__cphead" style={{ marginBottom: 10 }}>
                            <span className="fin-pp__cphead-ic"><FaImage size={17} /></span>
                            <div>
                                <h2 className="fin-pp__cphead-title" style={{ fontSize: 15 }}>Imagem de Fundo da Pesquisa</h2>
                                <p className="fin-pp__cphead-sub">
                                    Personaliza a tela que o participante vê ao responder. Sem imagem, a pesquisa usa o visual padrão. JPG, PNG ou WEBP. A imagem aparece <strong>inteira, sem cortes nem distorção</strong> — use uma arte horizontal (ex.: 1920×400).
                                </p>
                            </div>
                        </div>

                        {imagemFundo ? (
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, flexWrap: 'wrap' }}>
                                <a href={process.env.REACT_APP_API_URL + '/arquivo/download/' + imagemFundo.id + '?inline=1'}
                                    target="_blank" rel="noopener noreferrer" title="Abrir em tamanho real">
                                    <img
                                        src={process.env.REACT_APP_API_URL + '/arquivo/download/' + imagemFundo.id + '?inline=1'}
                                        alt="Imagem de fundo da pesquisa"
                                        style={{ maxWidth: 320, maxHeight: 180, objectFit: 'cover', borderRadius: 6, border: '1px solid var(--fin-bd)', display: 'block' }}
                                    />
                                </a>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                    <label className="fin-pp__btn fin-pp__btn--sm" style={{ marginBottom: 0, cursor: 'pointer' }}>
                                        {enviandoImagem ? 'Enviando...' : 'Trocar imagem'}
                                        <input type="file" accept=".jpg,.jpeg,.png,.webp" hidden disabled={enviandoImagem}
                                            onChange={e => { enviarImagemFundo(e.target.files?.[0]); e.target.value = ''; }} />
                                    </label>
                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger"
                                        onClick={excluirImagemFundo} disabled={enviandoImagem}>
                                        <FaTrash size={12} style={{ marginRight: 6 }} /> Remover
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <label className="fin-pp__btn fin-pp__btn--sm" style={{ marginBottom: 0, cursor: 'pointer' }}>
                                <FaImage size={13} style={{ marginRight: 6 }} />
                                {enviandoImagem ? 'Enviando...' : 'Escolher imagem'}
                                <input type="file" accept=".jpg,.jpeg,.png,.webp" hidden disabled={enviandoImagem}
                                    onChange={e => { enviarImagemFundo(e.target.files?.[0]); e.target.value = ''; }} />
                            </label>
                        )}

                        {/* Banner já vem com a marca na arte? Então não sobrepor
                            logo/nome/véu. Grava junto com o Salvar da tela. */}
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '12px 0 0', fontSize: '0.85rem', cursor: 'pointer' }}>
                            <input type="checkbox" checked={!!dados.ocultarmarcasatisfacao}
                                onChange={e => setDados({ ...dados, ocultarmarcasatisfacao: e.target.checked })} />
                            O banner já é personalizado — <strong>não sobrepor</strong> o logo do cliente e o nome do evento
                        </label>
                        {dados.ocultarmarcasatisfacao ? (
                            <p style={{ margin: '4px 0 0 24px', fontSize: '0.76rem', color: 'var(--fin-mt)' }}>
                                Lembre de clicar em <strong>Salvar</strong> para aplicar.
                            </p>
                        ) : null}
                    </div>

                    {/* ── Construtor de perguntas ─────────────────────────────
                        Um card por pergunta (não tabela: os campos mudam conforme o
                        tipo — nota tem De/Até e toggles; escolha tem lista de opções).
                        O TIPO define a resposta que o participante vê: nota (mapa de
                        calor), texto livre, escolha única ou múltipla escolha. */}
                    {/* ── Idiomas da pesquisa ─────────────────────────────
                        Marcar um idioma traduz TUDO automaticamente (Cloud
                        Translation) e grava; as abas abaixo servem para revisar. */}
                    {id && idiomasInfo.catalogo.length > 0 && (
                        <div className="fin-pp__card" style={{ padding: '14px 16px', marginBottom: 16 }}>
                            <div className="fin-pp__cphead" style={{ padding: 0, marginBottom: 8 }}>
                                <div style={{ minWidth: 0 }}>
                                    <h2 className="fin-pp__cphead-title">Idiomas da pesquisa</h2>
                                    <p className="fin-pp__cphead-sub">
                                        O participante escolhe o idioma na tela de entrada. Ao marcar um idioma,
                                        as perguntas são traduzidas automaticamente — revise na aba do idioma.
                                    </p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'center' }}>
                                {idiomasInfo.catalogo
                                    .filter(i => i.codigo !== 'portugues')
                                    .sort((a, b) => (a.codigo === 'espanhol' ? -1 : b.codigo === 'espanhol' ? 1 : 0))
                                    .map(i => (
                                        <label key={i.codigo} style={{ display: 'flex', alignItems: 'center', gap: 6, margin: 0, fontSize: '0.9rem', cursor: salvandoIdiomas ? 'wait' : 'pointer' }}>
                                            <input type="checkbox" disabled={salvandoIdiomas}
                                                checked={(idiomasInfo.oferecidos || []).includes(i.codigo)}
                                                onChange={() => alternarIdioma(i.codigo)} />
                                            {i.nome}
                                        </label>
                                    ))}
                                {salvandoIdiomas && <span style={{ fontSize: '0.8rem', color: 'var(--fin-mt)' }}>salvando e traduzindo…</span>}
                            </div>
                        </div>
                    )}

                    {/* Abas de idioma da lista: Português edita a estrutura; outro
                        idioma edita só os textos traduzidos. */}
                    {(idiomasInfo.oferecidos || []).length > 0 && (
                        <div className="fin-pp__tabs" style={{ marginBottom: 12 }}>
                            {[{ codigo: 'portugues', nome: 'Português' },
                              ...idiomasInfo.catalogo.filter(i => (idiomasInfo.oferecidos || []).includes(i.codigo))]
                                .map(i => (
                                    <button key={i.codigo} type="button"
                                        className={'fin-pp__tab' + (abaIdioma === i.codigo ? ' is-active' : '')}
                                        onClick={() => setAbaIdioma(i.codigo)}>
                                        {i.nome}
                                    </button>
                                ))}
                            {abaIdioma !== 'portugues' && (
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" style={{ marginLeft: 'auto' }}
                                    disabled={traduzindo} onClick={traduzirFaltantes}>
                                    {traduzindo ? 'Traduzindo…' : '⟳ Traduzir o que falta'}
                                </button>
                            )}
                        </div>
                    )}

                    {(() => {
                        const mut = (index, campo, valor) => {
                            const novas = [...perguntasSatisfacao];
                            novas[index] = { ...novas[index], [campo]: valor };
                            setPerguntasSatisfacao(novas);
                        };
                        const TIPOS = [
                            { v: 'nota', label: 'Nota (escala)' },
                            { v: 'texto', label: 'Texto livre' },
                            { v: 'escolha_unica', label: 'Escolha única' },
                            { v: 'multipla_escolha', label: 'Múltipla escolha' },
                        ];
                        return (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 }}>
                                {perguntasSatisfacao.length === 0 && (
                                    <div className="fin-pp__card" style={{ padding: 18, textAlign: 'center', color: 'var(--fin-mt)' }}>
                                        Nenhuma pergunta adicionada
                                    </div>
                                )}
                                {perguntasSatisfacao.map((pergunta, index) => {
                                    const tipo = pergunta.tipoResposta || 'nota';
                                    const ehEscolha = tipo === 'escolha_unica' || tipo === 'multipla_escolha';

                                    // ── Modo tradução: português de um lado (só leitura),
                                    // o idioma da aba do outro. Estrutura não se edita aqui.
                                    if (abaIdioma !== 'portugues') {
                                        if (!pergunta.id) {
                                            return (
                                                <div key={'nova-' + index} className="fin-pp__card" style={{ padding: '12px 16px', color: 'var(--fin-mt)', fontSize: '0.85rem' }}>
                                                    {index + 1}. Salve a pergunta em português primeiro para traduzi-la.
                                                </div>
                                            );
                                        }
                                        const chave = abaIdioma + ':' + pergunta.id;
                                        const t = traducoes[chave] || { pergunta_texto: '', instrucao: '', opcoesTexto: '' };
                                        const itensPt = (pergunta.opcoesTexto || '').split('\n').map(x => x.trim()).filter(Boolean);
                                        return (
                                            <div key={pergunta.id} className="fin-pp__card" style={{ padding: '14px 16px' }}>
                                                <div style={{ fontSize: '0.8rem', color: 'var(--fin-mt)', marginBottom: 6 }}>
                                                    <strong>{index + 1}.</strong> {pergunta.pergunta || '(sem texto)'}
                                                    {pergunta.instrucao ? <span> · <em>{pergunta.instrucao}</em></span> : null}
                                                </div>
                                                <input type="text" className="fin-pp__input"
                                                    style={{ width: '100%', paddingLeft: 14 }}
                                                    placeholder="Tradução da pergunta…"
                                                    value={t.pergunta_texto}
                                                    onChange={e => mutTraducao(pergunta.id, 'pergunta_texto', e.target.value)} />
                                                {!!pergunta.instrucao && (
                                                    <input type="text" className="fin-pp__input"
                                                        style={{ width: '100%', paddingLeft: 14, marginTop: 8 }}
                                                        placeholder="Tradução da instrução…"
                                                        value={t.instrucao}
                                                        onChange={e => mutTraducao(pergunta.id, 'instrucao', e.target.value)} />
                                                )}
                                                {ehEscolha && itensPt.length > 0 && (
                                                    <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
                                                        <div style={{ flex: 1, fontSize: '0.8rem', color: 'var(--fin-mt)', lineHeight: '1.9' }}>
                                                            {itensPt.map((op, i) => <div key={i}>{op}</div>)}
                                                        </div>
                                                        <textarea className="fin-pp__input" rows={Math.max(3, itensPt.length)}
                                                            style={{ flex: 1, paddingLeft: 14, paddingTop: 8, resize: 'vertical', lineHeight: 1.5, height: 'auto' }}
                                                            placeholder={'Uma opção traduzida por linha, na MESMA ordem'}
                                                            value={t.opcoesTexto}
                                                            onChange={e => mutTraducao(pergunta.id, 'opcoesTexto', e.target.value)} />
                                                    </div>
                                                )}
                                                {ehEscolha && itensPt.length > 0 && (
                                                    (t.opcoesTexto || '').split('\n').map(x => x.trim()).filter(Boolean).length !== itensPt.length && (
                                                        <p style={{ margin: '6px 0 0', fontSize: '0.78rem', color: 'var(--fin-dg)' }}>
                                                            A tradução precisa ter o mesmo número de opções ({itensPt.length}) e na mesma ordem —
                                                            é pela posição que o sistema pareia os idiomas.
                                                        </p>
                                                    )
                                                )}
                                            </div>
                                        );
                                    }

                                    return (
                                        <div key={pergunta.id ?? 'nova-' + index} className="fin-pp__card" style={{ padding: '14px 16px' }}>
                                            {/* linha 1: nº · tipo · pergunta · remover */}
                                            <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', flexWrap: 'wrap' }}>
                                                <span style={{ fontWeight: 700, color: 'var(--fin-mt)', paddingTop: 8, minWidth: 24 }}>{index + 1}.</span>
                                                <select className="fin-pp__select" style={{ width: 170 }}
                                                    value={tipo}
                                                    onChange={e => mut(index, 'tipoResposta', e.target.value)}>
                                                    {TIPOS.map(t => <option key={t.v} value={t.v}>{t.label}</option>)}
                                                </select>
                                                <input type="text" className="fin-pp__input"
                                                    style={{ flex: 1, minWidth: 220, paddingLeft: 14 }}
                                                    placeholder="Texto da pergunta..."
                                                    value={pergunta.pergunta || ''}
                                                    onChange={e => mut(index, 'pergunta', e.target.value)} />
                                                <button type="button" className="fin-pp__btn fin-pp__btn--danger fin-pp__btn--sm" title="Remover"
                                                    onClick={() => removerPergunta(index)}>
                                                    <FaTrash size={13} />
                                                </button>
                                            </div>

                                            {/* linha 2: seção e instrução (valem para todo tipo) */}
                                            <div style={{ display: 'flex', gap: 10, marginTop: 8, flexWrap: 'wrap' }}>
                                                <input type="text" className="fin-pp__input" style={{ width: 240, paddingLeft: 14 }}
                                                    placeholder="Seção (ex.: Organização e logística)"
                                                    title="Cabeçalho mostrado ao participante — agrupa as perguntas por bloco"
                                                    value={pergunta.secao || ''}
                                                    onChange={e => mut(index, 'secao', e.target.value)} />
                                                <input type="text" className="fin-pp__input" style={{ flex: 1, minWidth: 220, paddingLeft: 14 }}
                                                    placeholder="Instrução (opcional — ex.: Marque todas as opções aplicáveis)"
                                                    value={pergunta.instrucao || ''}
                                                    onChange={e => mut(index, 'instrucao', e.target.value)} />
                                            </div>

                                            {/* linha 3: específico do tipo */}
                                            {tipo === 'nota' && (
                                                <div style={{ display: 'flex', gap: 16, marginTop: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                                                    <label style={{ display: 'flex', alignItems: 'center', gap: 6, margin: 0, fontSize: '0.85rem' }}>
                                                        De
                                                        <input type="number" min="0" max="10" className="fin-pp__input" style={{ width: 70, paddingLeft: 12 }}
                                                            value={pergunta.notaMin ?? 0}
                                                            onChange={e => mut(index, 'notaMin', parseInt(e.target.value, 10) || 0)} />
                                                        até
                                                        <input type="number" min="0" max="10" className="fin-pp__input" style={{ width: 70, paddingLeft: 12 }}
                                                            value={pergunta.notaMax ?? 10}
                                                            onChange={e => mut(index, 'notaMax', parseInt(e.target.value, 10) || 10)} />
                                                    </label>
                                                    <label style={{ display: 'flex', alignItems: 'center', gap: 6, margin: 0, fontSize: '0.85rem', cursor: 'pointer' }}
                                                        title='Mostra o botão "Não participei" — para itens que nem todos viveram (ex.: visitas externas)'>
                                                        <input type="checkbox" checked={!!pergunta.permiteNaoParticipei}
                                                            onChange={e => mut(index, 'permiteNaoParticipei', e.target.checked)} />
                                                        Permitir "Não participei"
                                                    </label>
                                                    <label style={{ display: 'flex', alignItems: 'center', gap: 6, margin: 0, fontSize: '0.85rem', cursor: 'pointer' }}
                                                        title="Marca esta pergunta como o indicador NPS do evento">
                                                        <input type="checkbox" checked={!!pergunta.nps}
                                                            onChange={e => mut(index, 'nps', e.target.checked)} />
                                                        Indicador NPS
                                                    </label>
                                                </div>
                                            )}
                                            {ehEscolha && (
                                                <div style={{ marginTop: 8 }}>
                                                    <textarea className="fin-pp__input" rows={3}
                                                        style={{ width: '100%', paddingLeft: 14, paddingTop: 8, resize: 'vertical', lineHeight: 1.5 }}
                                                        placeholder={'Uma opção por linha, ex.:\nCongressista\nPalestrante\nImprensa'}
                                                        value={pergunta.opcoesTexto || ''}
                                                        onChange={e => mut(index, 'opcoesTexto', e.target.value)} />
                                                    <div style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap', marginTop: 6 }}>
                                                        {tipo === 'escolha_unica' && (
                                                            <label style={{ display: 'flex', alignItems: 'center', gap: 6, margin: 0, fontSize: '0.85rem', cursor: 'pointer' }}>
                                                                <input type="checkbox" checked={!!pergunta.permiteOutro}
                                                                    onChange={e => mut(index, 'permiteOutro', e.target.checked)} />
                                                                Permitir "Outro" (campo livre)
                                                            </label>
                                                        )}
                                                        {/* Pulo de seção: quem escolher esta opção não vê o resto da
                                                            seção (ex.: "Não participei das visitas externas"). */}
                                                        <label style={{ display: 'flex', alignItems: 'center', gap: 6, margin: 0, fontSize: '0.85rem' }}
                                                            title="Quem escolher esta opção pula todas as perguntas seguintes da MESMA seção">
                                                            Opção que encerra a seção:
                                                            <select className="fin-pp__select" style={{ width: 220 }}
                                                                value={pergunta.encerraSecao || ''}
                                                                onChange={e => mut(index, 'encerraSecao', e.target.value)}>
                                                                <option value="">— nenhuma —</option>
                                                                {(pergunta.opcoesTexto || '').split('\n').map(x => x.trim()).filter(Boolean).map(op => (
                                                                    <option key={op} value={op}>{op}</option>
                                                                ))}
                                                            </select>
                                                        </label>
                                                    </div>

                                                    {/* Uma pergunta por opção: o participante que marcou SENAI
                                                        avalia só o SENAI. O motor é o mesmo "mostrar apenas se
                                                        marcou" — isto só monta e amarra tudo de uma vez. */}
                                                    <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px dashed var(--fin-bd)' }}>
                                                        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                                                            <span style={{ fontSize: '0.82rem', color: 'var(--fin-mt)', whiteSpace: 'nowrap' }}>
                                                                Gerar uma pergunta para cada opção:
                                                            </span>
                                                            <input type="text" className="fin-pp__input"
                                                                style={{ flex: 1, minWidth: 240, paddingLeft: 14 }}
                                                                placeholder={MODELO_PADRAO}
                                                                title="Escreva o texto como quiser — {item} vira o nome da opção"
                                                                value={pergunta.modeloItem != null ? pergunta.modeloItem : MODELO_PADRAO}
                                                                onChange={e => mut(index, 'modeloItem', e.target.value)} />
                                                            <select className="fin-pp__select" style={{ width: 150 }}
                                                                title="Tipo das perguntas geradas"
                                                                value={pergunta.tipoItem || 'nota'}
                                                                onChange={e => mut(index, 'tipoItem', e.target.value)}>
                                                                <option value="nota">Nota (escala)</option>
                                                                <option value="texto">Texto livre</option>
                                                            </select>
                                                            <button type="button" className="fin-pp__btn fin-pp__btn--sm"
                                                                onClick={() => gerarPerguntasPorOpcao(index)}>
                                                                <FaMagic size={12} /> Gerar
                                                            </button>
                                                        </div>
                                                        <p style={{ margin: '6px 0 0', fontSize: '0.78rem', color: 'var(--fin-mt)' }}>
                                                            Escreva <code>{'{item}'}</code> onde entra o nome da opção. Cada pergunta gerada
                                                            aparece só para quem marcar aquela opção — e clicar de novo cria apenas as que faltam.
                                                        </p>
                                                    </div>
                                                </div>
                                            )}
                                            {tipo === 'texto' && (
                                                <p style={{ margin: '8px 0 0', fontSize: '0.8rem', color: 'var(--fin-mt)' }}>
                                                    O participante escreve livremente (pode deixar em branco, como no papel).
                                                </p>
                                            )}

                                            {/* ── Condição: mostrar só se marcou X na pergunta N ─────
                                                Fonte referenciada pelo ÍNDICE (pergunta nova ainda não
                                                tem id); o backend converte para id ao salvar. */}
                                            {(() => {
                                                const fontes = perguntasSatisfacao
                                                    .map((f, fi) => ({ f, fi }))
                                                    .filter(({ f, fi }) => fi < index && (f.tipoResposta === 'escolha_unica' || f.tipoResposta === 'multipla_escolha'));
                                                if (fontes.length === 0) return null;
                                                const fonteSel = pergunta.condicaoIndex !== '' && pergunta.condicaoIndex != null
                                                    ? perguntasSatisfacao[pergunta.condicaoIndex] : null;
                                                const opcoesFonte = fonteSel ? itensDe(fonteSel) : [];
                                                // Opção renomeada ou apagada na fonte: a pergunta fica presa a algo
                                                // que não existe mais. Avisar, nunca apagar por conta própria.
                                                const orfa = !!(fonteSel && pergunta.condicaoOpcao && !opcoesFonte.includes(pergunta.condicaoOpcao));
                                                return (
                                                    <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginTop: 8, paddingTop: 8, borderTop: '1px dashed var(--fin-brd)' }}>
                                                        <span style={{ fontSize: '0.82rem', color: 'var(--fin-mt)' }}>Mostrar apenas se marcou</span>
                                                        <select className="fin-pp__select" style={{ width: 200 }}
                                                            value={pergunta.condicaoIndex === '' || pergunta.condicaoIndex == null ? '' : String(pergunta.condicaoIndex)}
                                                            onChange={e => {
                                                                const v = e.target.value === '' ? '' : parseInt(e.target.value, 10);
                                                                const novas = [...perguntasSatisfacao];
                                                                novas[index] = { ...novas[index], condicaoIndex: v, condicaoOpcao: '' };
                                                                setPerguntasSatisfacao(novas);
                                                            }}>
                                                            <option value="">— sempre mostrar —</option>
                                                            {fontes.map(({ f, fi }) => (
                                                                <option key={fi} value={fi}>{(fi + 1) + '. ' + (f.pergunta || '(sem texto)').slice(0, 40)}</option>
                                                            ))}
                                                        </select>
                                                        {fonteSel && (<>
                                                            <span style={{ fontSize: '0.82rem', color: 'var(--fin-mt)' }}>a opção</span>
                                                            <select className="fin-pp__select" style={{ width: 220 }}
                                                                value={pergunta.condicaoOpcao || ''}
                                                                onChange={e => mut(index, 'condicaoOpcao', e.target.value)}>
                                                                <option value="">— escolha —</option>
                                                                {opcoesFonte.map(op => <option key={op} value={op}>{op}</option>)}
                                                            </select>
                                                        </>)}
                                                        {orfa && (
                                                            <div style={{ width: '100%', marginTop: 6, padding: '6px 10px', borderRadius: 'var(--fin-rds)', background: 'var(--fin-dgb)', color: 'var(--fin-dg)', fontSize: '0.8rem' }}>
                                                                A opção &quot;{pergunta.condicaoOpcao}&quot; não existe mais na pergunta {pergunta.condicaoIndex + 1} —
                                                                do jeito que está, esta pergunta não aparece para ninguém. Escolha a opção certa ao lado ou remova a pergunta.
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })()}
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })()}

                    {abaIdioma !== 'portugues' && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 24 }}>
                            <button type="button" className="fin-pp__btn fin-pp__btn--ok" disabled={salvandoTraducoes}
                                onClick={salvarTraducoes}>
                                {salvandoTraducoes ? 'Salvando…' : '💾 Salvar traduções'}
                            </button>
                        </div>
                    )}
                    <div style={{ display: abaIdioma === 'portugues' ? 'flex' : 'none', justifyContent: 'space-between', marginBottom: 24 }}>
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--primary"
                            onClick={() => {
                                setPerguntasSatisfacao([...perguntasSatisfacao, { pergunta: '', notaMin: 0, notaMax: 10, tipoResposta: 'nota', secao: '', instrucao: '', permiteNaoParticipei: false, nps: false, opcoesTexto: '', permiteOutro: false }]);
                            }}
                        >
                            <FaPlus size={14} /> Adicionar Pergunta
                        </button>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting}>
                            {isSubmitting ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</> : <><FaSave size={16} /> Salvar</>}
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
